import { Site } from '@envato/foundation-types'

export default [
  {
    key: 'elements',
    label: 'Envato Elements',
    imageSrc: '/images/cross-sell__elements.jpg',
    imageSrcSet: [
      '/images/cross-sell__elements.jpg',
      '/images/cross-sell__elements--2x.jpg'
    ],
    heading: 'Deliver better projects faster. Web, design & video assets',
    subHeading: 'Unlimited downloads, from $16.50/month',
    url: {
      base: { default: 'https://elements.envato.com/' },
      path: { default: 'pricing' },
      params: {
        [Site.themeforest]: {
          utm_source: 'themeforest.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: 'tf_global-footer',
          utm_medium: 'promos'
        },
        [Site.codecanyon]: {
          utm_source: 'codecanyon.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: 'cc_global-footer',
          utm_medium: 'promos'
        },
        [Site.graphicriver]: {
          utm_source: 'graphicriver.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: 'gr_global-footer',
          utm_medium: 'promos'
        },
        [Site.photodune]: {
          utm_source: 'photodune.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: 'pd_global-footer',
          utm_medium: 'promos'
        },
        [Site.videohive]: {
          utm_source: 'videohive.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: 'vh_global-footer',
          utm_medium: 'promos'
        },
        [Site.audiojungle]: {
          utm_source: 'audiojungle.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: 'aj_global-footer',
          utm_medium: 'promos'
        },
        [Site.threedocean]: {
          utm_source: '3docean.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: '3do_global-footer',
          utm_medium: 'promos'
        }
      }
    }
  },
  {
    key: 'placeit',
    label: 'Placeit',
    imageSrc: '/images/cross-sell__placeit.jpg',
    imageSrcSet: [
      '/images/cross-sell__placeit.jpg',
      '/images/cross-sell__placeit--2x.jpg'
    ],
    heading: 'Create Beautiful Logos, Designs <br>&amp; Mockups in Seconds',
    subHeading: 'Design like a professional without Photoshop',
    url: {
      base: {
        default: 'http://placeit.net'
      },
      path: {
        default: ''
      },
      params: {
        [Site.codecanyon]: {
          utm_source: 'codecanyon.net',
          utm_medium: 'promos',
          utm_content: 'cc_global-footer',
          utm_campaign: 'placeit_mkt-footer'
        },
        [Site.themeforest]: {
          utm_source: 'themeforest.net',
          utm_medium: 'promos',
          utm_content: 'tf_global-footer',
          utm_campaign: 'placeit_mkt-footer'
        },
        [Site.graphicriver]: {
          utm_source: 'graphicriver.net',
          utm_medium: 'promos',
          utm_content: 'gr_global-footer',
          utm_campaign: 'placeit_mkt-footer'
        },
        [Site.videohive]: {
          utm_source: 'videohive.net',
          utm_medium: 'promos',
          utm_content: 'vh_global-footer',
          utm_campaign: 'placeit_mkt-footer'
        },
        [Site.audiojungle]: {
          utm_source: 'audiojungle.net',
          utm_medium: 'promos',
          utm_content: 'aj_global-footer',
          utm_campaign: 'placeit_mkt-footer'
        },
        [Site.photodune]: {
          utm_source: 'photodune.net',
          utm_medium: 'promos',
          utm_content: 'pd_global-footer',
          utm_campaign: 'placeit_mkt-footer'
        },
        [Site.threedocean]: {
          utm_source: '3docean.net',
          utm_medium: 'promos',
          utm_content: '3d_global-footer',
          utm_campaign: 'placeit_mkt-footer'
        },
        default: {
          utm_source: 'EnvatoMarket',
          utm_medium: 'promos',
          utm_content: 'global-footer',
          utm_campaign: 'placeit_mkt-footer'
        }
      }
    }
  },
  {
    key: 'studio',
    label: 'Envato Studio',
    imageSrc: '/images/cross-sell__studio.jpg',
    imageSrcSet: [
      '/images/cross-sell__studio.jpg',
      '/images/cross-sell__studio--2x.jpg'
    ],
    heading: 'Designers matched perfectly to<br>you on Envato Studio',
    subHeading: '2000 artists ready to undertake your work',
    url: {
      base: {
        default: 'https://studio.envato.com'
      },
      path: {
        [Site.codecanyon]: '/explore/websites-programming',
        [Site.videohive]: '/explore/video-animation',
        [Site.audiojungle]: '/explore/audio',
        [Site.graphicriver]: '/explore/design-graphics',
        [Site.photodune]: '/explore/photo-editing',
        [Site.threedocean]: '/explore/3d-design-modeling',
        default: '/explore/wordpress'
      },
      params: {
        [Site.threedocean]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: '3docean'
        },
        [Site.audiojungle]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'audiojungle'
        },
        [Site.codecanyon]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'codecanyon'
        },
        [Site.graphicriver]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'graphicriver'
        },
        [Site.photodune]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'photodune'
        },
        [Site.themeforest]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'themeforest'
        },
        [Site.videohive]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'videohive'
        },
        default: {}
      }
    }
  }
]
